/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".share{width:280px}.share-button{position:relative;z-index:1;display:block;width:100%;line-height:20px;padding:12px;border:none;-webkit-box-sizing:border-box;box-sizing:border-box;text-align:left;background:0 0;font-size:14px;color:#000}.share-button:hover{background:rgba(0,0,0,.05)}.share-button__badge{position:absolute;top:50%;right:12px;line-height:20px;margin-top:-10px;padding:0 10px;border-radius:2px;background:#3d9fea;color:#fff;font-weight:700;font-size:10px;text-transform:uppercase}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/rec/components/share/share.component.styl.ngstyle.js.pre-build-optimizer.js